/**
 * Wire format for date ranges: one preset token, or a start/end pair of expressions.
 */
export type DateRangeExpression = readonly [string] | readonly [string, string];

/** Single-token presets (entire range). */
export const DATE_RANGE_SINGLE_PRESETS = [
	'today',
	'yesterday',
	'thisWeek',
	'thisMonth',
	'thisYear',
	'lastWeek',
	'lastMonth',
	'lastYear',
	'last7days',
	'last30days',
	'last90days',
] as const;

export type DateRangeSinglePreset = (typeof DATE_RANGE_SINGLE_PRESETS)[number];

/** Endpoint tokens valid in a two-element range (includes presets and anchors). */
export const DATE_RANGE_ENDPOINT_TOKENS = [
	...DATE_RANGE_SINGLE_PRESETS,
	'today',
	'yesterday',
] as const;

export interface ResolvedDateRangeExpression {
	startDate: Date;
	endDate: Date;
	expression: DateRangeExpression;
}
